export const phoneCustomize = (number: string) => number.replace(/^(\+\d{3})(\d{2})(\d{3})(\d{2})(\d{2})$/, '$1 ($2) $3-$4-$5');
